import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';

import { parseSum } from 'utils/helpers';
import { theme } from 'config';
import { texts } from 'utils/languages/fr';

import { CustomSelect, Loader } from 'components';
import { Typography, Paper, MenuItem, Box } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        height: '100%',
    },
}));

const chartOptions = {
    legend: { show: false },
    chart: {
        type: 'bar',
        stacked: true,
        toolbar: { show: false },
    },
    theme: {
        mode: 'light',
        palette: 'palette1',
        monochrome: {
            enabled: true,
            color: theme.palette.primary.main,
            shadeTo: 'light',
            shadeIntensity: 0.75,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    yaxis: {
        tickAmount: 8,
        labels: { formatter: val => parseSum(val) },
    },
    fill: {
        opacity: 1,
    },
    tooltip: {
        y: { formatter: val => parseSum(val) },
    },
};

const getChartCategories = () =>
    [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].reduce((acc, crt) => {
        return acc.concat([moment().subtract(crt, 'month')]);
    }, []);

const DataContainer = props => {
    const { chartSeries, products, chartCategories, product, setProduct, title, loading } = props;
    const classes = useStyles();
    const categories = useMemo(
        () => chartCategories || getChartCategories().map(x => x.format("MMM 'YY")),
        [chartCategories]
    );

    return (
        <Paper elevation={0} className={classes.paper}>
            <Typography variant="subtitle1" align="center" gutterBottom>
                {title}
            </Typography>
            <CustomSelect
                label={texts.PRODUIT}
                value={product}
                onChange={e => setProduct(e.target.value)}
            >
                <MenuItem value="all">{texts.ALL_1}</MenuItem>
                {products.map(f => (
                    <MenuItem key={f.id} value={f.id}>
                        {f.name}
                    </MenuItem>
                ))}
            </CustomSelect>
            <Loader loading={loading} height="100%">
                {chartSeries.length ? (
                    <Chart
                        type="bar"
                        options={{
                            ...chartOptions,
                            xaxis: { categories },
                        }}
                        series={chartSeries}
                        height={320}
                    />
                ) : (
                    <Box height="120px" paddingTop={8}>
                        <Typography variant="subtitle2" align="center">
                            {texts.NO_DATA_AVAILABLE}
                        </Typography>
                    </Box>
                )}
            </Loader>
        </Paper>
    );
};

export default DataContainer;
